<div class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 col-sm-3 opac">Todos los derechos reservados</div>
            <div class="col-xs-12 col-sm-6 text-center opac">
                <span><a [routerLink]="['/dashboard/premiun']" routerLinkActive="router-link-active" >Premiun</a></span> | 
                <!--span><a [routerLink]="['/dashboard/premiun']" routerLinkActive="router-link-active" > Preguntas frecuentes </a></span> | -->
                <a href="#" (click)="irContactenos()" routerLinkActive="router-link-active" >Contáctanos</a>
            </div>
            <div class="col-xs-12 col-sm-3 text-right"><a href="https://convoca.pe" target="_blank"><img src="assets/img/convoca.png"></a></div>
        </div>
    </div>
</div>
